import { z } from 'zod'
export const projectInfoSchema = z.object({
    internalProjectTitle: z
        .string({ required_error: "Title is required", invalid_type_error: "Title must be type string" })
        .trim()
        .min(3, "Title must be at least 3 characters")
        .max(150, "Title cannot exceed 150 characters"),
    internalProjectDescription: z
        .string({ required_error: "Description is required", invalid_type_error: "Description must be type string" })
        .trim()
        .min(3, "Description must be at least 3 characters")
        .max(1000, "Description cannot exceed 1000 characters")
    // .optional()
    ,
}, { invalid_type_error: "Project info must be type object", required_error: "Project info is required", });
export const createDraftSchema = z.object({
    organization: z.string({ required_error: "Organization ID is required", invalid_type_error: "Organization ID must be type string" }).trim(),
    projectInfo: projectInfoSchema,
});